<div class="modal-overlay" *ngIf="modalData" (click)="close()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header" [class.error]="modalData.isError">
      <h2>{{ modalData.title }}</h2>
      <button class="modal-close-btn" (click)="close()">×</button>
    </div>
    <div class="modal-body">
      <!-- Usamos [innerHTML] para poder renderizar saltos de línea si es necesario -->
      <p [innerHTML]="modalData.message"></p>

      <!-- New: Dropdown for status options -->
      <div *ngIf="modalData.statusOptions?.length" class="status-selector">
        <label for="status-select">Seleccionar nuevo estado:</label>
        <select id="status-select" [(ngModel)]="selectedStatus">
          <option *ngFor="let option of modalData.statusOptions" [value]="option">
            {{ option | titlecase }}
          </option>
        </select>
      </div>

    </div>
    <div class="modal-footer">
      <!-- Si es un modal de confirmación -->
      <ng-container *ngIf="modalData.confirmText">
        <button class="btn-modal btn-cancel" (click)="confirm(false)">
          {{ modalData.cancelText || 'Cancelar' }}
        </button>
        <button class="btn-modal btn-confirm" [class.error]="modalData.isError" (click)="confirm(true)">
          {{ modalData.confirmText }}
        </button>
      </ng-container>

      <!-- Si es un modal de solo información -->
      <ng-container *ngIf="!modalData.confirmText">
        <button class="btn-modal btn-modal-ok" (click)="close()" [class.error]="modalData.isError">
          Entendido
        </button>
      </ng-container>
    </div>
  </div>
</div>
